'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useRef } from 'react';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { usePublishElementHeight } from '@/hooks/usePublishElementHeight';
import { useGlobalStore } from '@/stores/GlobalStore';
import { DonationBnb } from './_components/DonationBnb';
import { LocalMarketBnb } from './_components/LocalMarketBnb';
import { getFloatingBnbKind } from './constants';

//* --safe-area-bottom은 SAFE_AREA_BOOTSTRAP_SCRIPT가 첫 페인트 전 확정하고 문서 수명 동안
//* 불변이다(클라 번들 평가는 항상 그 뒤). 상태 구독으로 읽으면 브릿지 응답 시점에 publish
//* 값이 튀어 토스트·채널톡(--toast-bottom 소비처)이 덜컹인다 — 모듈 상수 1회 읽기로 고정.
const SAFE_AREA_BOTTOM = typeof document === 'undefined' ? 0 : Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-bottom'), 10) || 0;
export const FloatingBnbController = () => {
  const $ = _c(12);
  const pathname = usePathname();
  const hideBottomNav = useGlobalStore(_temp);
  let t0;
  if ($[0] !== hideBottomNav || $[1] !== pathname) {
    t0 = hideBottomNav ? null : getFloatingBnbKind(pathname);
    $[0] = hideBottomNav;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const activeBnb = t0;
  const bnbRef = useRef(null);
  const t1 = !!activeBnb;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      enabled: t1,
      extraOffset: 10 + SAFE_AREA_BOTTOM
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  usePublishElementHeight(bnbRef, "--floating-bnb-height", t2);
  let t3;
  if ($[5] !== activeBnb) {
    t3 = activeBnb === "donation" && <DonationBnb isMounted={true} />;
    $[5] = activeBnb;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeBnb) {
    t4 = activeBnb === "localMarket" && <LocalMarketBnb />;
    $[7] = activeBnb;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Portal renderTo={getMainWrapperElement}><div ref={bnbRef} className="fixed inset-x-0 bottom-[calc(10px+var(--safe-area-bottom,0px))] z-20 hidden w-full mobile-tablet:block">{t3}{t4}</div></Portal>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
function _temp(state) {
  return state.hideBottomNav;
}